import React, { Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from '../Title'
import './style.scss'

// images
import teamMember1 from '../../images/expert/2.jpg'
import teamMember2 from '../../images/expert/1.jpg'
import {Link} from "react-router-dom";


const infoTeam = [
    {
        infoTeam: 'We are cousins and moms who value our family above all. Because of these values, we bring a fresh, compassionate perspective and contemporary approach to protecting your family’s future. We were inspired to start this firm because we recognized a crucial need: families and individuals like us who seek personalized, accessible estate planning services.'
    },
]

const teams = [
    {
        name: 'Kimberly Zierman', slug: 'kimberly-zierman', level: 'Partner', image: teamMember2, socialMedia: [
            'linkedin'
        ]
    },
    {
        name: 'Jennifer Estrada ', slug: 'jennifer-estrada', level: 'Partner', image: teamMember1, socialMedia: [
            'linkedin'
        ]
    },

]

const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};
const TeamMember = ({ className, title, subTitle, slider, noGutters, infoTeam }) => {
    return (
        <div className={className}>
            <div className="container">
                <div className={!noGutters ? 'row' : 'row no-gutters'}>
                    <div className="col-12">
                        <SectionTitle
                            title={title}
                            subTitle={subTitle}
                            infoTeam={infoTeam}
                        />
                    </div>

                        <div className="col-12">
                            <Slider className="teamSlideArea" {...settings}>
                                {teams.map((team, i) => (
                                    <Link key={i} to={`/teams-single/${team.slug}`}>
                                    <div key={i} className="teamWrapper">
                                        <div className="teamImage">
                                            <img src={team.image} alt="" />
                                        </div>
                                        <div className="teamContent">
                                            <h3>{team.name}</h3>
                                            <span>{team.level}</span>
                                            <ul>
                                                {team.socialMedia.map(social => (
                                                    <li key={social}><a href="#"><i className={`fa fa-${social}`} aria-hidden="true"></i></a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                        </Link>
                                ))}
                            </Slider>
                        </div>


                </div>
            </div>
        </div>
    )
}
export default TeamMember